import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import $http from "./http";
import sharp from "./wechatShare";
import simage from './assets/img/share.jpg'//引入图片
Vue.use(Router);

const routes = [
    {
        path: "/",
        name: "home",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划",
            share: {
                title: "阳光关爱·i读计划",
                descp: '中国社会福利基金会、东风日产、南方周末联合发起的儿童阅读推广项目“阳光关爱·i读计划”活动官网',
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url :'https://www.sunlove-iread.com'
            }
        },
        component: () => import("./components/router/index.vue")
    },
    {
        path: "/volunteer",
        name: "volunteer",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 成为志愿者",
            share: {
                title: "阳光关爱·i读计划 - 成为志愿者",
                descp: "助力乡村儿童阅读推广，期待您的加入。",
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url :'https://www.sunlove-iread.com/volunteer'
            }
        },
        component: () => import("./components/router/volunteer.vue")
    },
    {
        path: "/volunteer2",
        name: "volunteer2",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 成为志愿者",
            share: {
                title: "阳光关爱·i读计划 - 成为志愿者",
                descp: "助力乡村儿童阅读推广，期待您的加入。",
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url :'https://www.sunlove-iread.com/volunteer'
            }
        },
        component: () => import("./components/router/volunteer2.vue")
    },
    {
        path: "/readingtips",
        name: "readingtips",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 阳光领读人",
            share: {
                title: "阳光关爱·i读计划 - 阳光领读人",
                descp: "助力乡村儿童阅读推广，期待您的加入。",
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url :'https://www.sunlove-iread.com/readingtips'
            }
        },
        component: () => import("./components/router/readingtips.vue")
    },
    {
        path: "/video",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 活动视频",
            share: {
                title: "阳光关爱·i读计划 - 活动视频",
                descp: '中国社会福利基金会、东风日产、南方周末联合发起的儿童阅读推广项目“阳光关爱·i读计划”活动官网',
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url :'https://www.sunlove-iread.com'
            }
        },
        component: () => import("./components/router/video.vue")
    },
    {
        path: "/video/:p",
        name: "video",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 活动视频",
            share: {
                title: "阳光关爱·i读计划 - 活动视频",
                descp: '中国社会福利基金会、东风日产、南方周末联合发起的儿童阅读推广项目“阳光关爱·i读计划”活动官网',
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url :'https://www.sunlove-iread.com'
            }
        },
        component: () => import("./components/router/video.vue")
    },
    {
        path: "/video/:tags/:p",
        name: "video-tags",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 活动视频",
            share: {
                title: "阳光关爱·i读计划 - 活动视频",
                descp: '中国社会福利基金会、东风日产、南方周末联合发起的儿童阅读推广项目“阳光关爱·i读计划”活动官网',
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url :'https://www.sunlove-iread.com'
            }
        },
        component: () => import("./components/router/video.vue")
    },
    {
        path: "/vbanner",
        name: "vbanner",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 活动视频"
        },
        component: () => import("./components/router/vbanner.vue")
    },
    {
        path: "/image/:p",
        name: "image",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 精彩图集"
        },
        component: () => import("./components/router/image.vue")
    },

    {
        path: "/image",
        redirect:'/image/1',
    },
    
    {
        path: "/action",
        redirect:'/action/1',
    },
    {
        path: "/action/:p",
        name: "action",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 动态资讯"
        },
        component: () => import("./components/router/action.vue")
    },
    {
        path: "/adetail/:id",
        name: "adetail",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 动态资讯"
        },
        component: () => import("./components/router/actionDetail.vue")
    },
    {
        path: "/vdetail/:id",
        name: "vdetail",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 活动视频"
        },
        component: () => import("./components/router/videoDetail.vue")
    },
    {
        path: "/idetail/:id",
        name: "idetail",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 精彩图集"
        },
        component: () => import("./components/router/imageDetail.vue")
    },
    {
        path: "/about",
        name: "about",
        meta: {
            index: 10,
            title: "阳光关爱·i读计划 - 关于"
        },
        component: () => import("./components/router/about.vue")
    },

    {
        path: "*",
        redirect: "/"
    },

];

// add route path
// routes.forEach(route => {
//   route.path = route.path || '/' + (route.name || '');
// });

const router = new Router({
    // mode: 'history',
    mode: process.env.VUE_APP_ROUTER_MODE,
    routes: routes,
});
var noacl = [];

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0); //滚动条回到顶部
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    store.commit("refreshRouterKey");
    // console.log(to.meta);
    setTimeout(()=>{
        let sharpDefault = {};
        if (to.meta && to.meta.share) {
             sharpDefault =to.meta.share;
        } else {
             sharpDefault = {
                title: "阳光关爱·i读计划",
                descp: '中国社会福利基金会、东风日产、南方周末联合发起的儿童阅读推广项目“阳光关爱·i读计划”活动官网',
                icon: "https://img.sunlove-iread.com/static/img/share.jpg#" + Math.random(),
                url: location.href.split('#')[0]
            }
        }
        sharp.ready(sharpDefault);
        if(isApp()){
        JSBinder.activityDetails(sharpDefault.title, sharpDefault.desc, sharpDefault.icon, sharpDefault.url);
        }
    },200)
    next();
});
function isApp() {
    if (typeof window.JSBinder != 'undefined') {
        return true;
    }
    return false;
}

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

export {
    router
};